import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToken } from "../context/TokenContext";
import { isNativeApp, showRewardedAd } from "../utils/nativeBridge";
import YildizArkaplan from "../components/YildizArkaplan";

export default function TokenKazan() {
  const navigate = useNavigate();
  const { tokenBalance, user, ekleToken } = useToken();
  const [yukleniyor, setYukleniyor] = useState(false);
  const [mesaj, setMesaj] = useState(null);

  const isNativeApp_ = isNativeApp();

  function goster(metin, tur = 'basari') {
    setMesaj({ metin, tur });
    setTimeout(() => setMesaj(null), 3000);
  }

  const reklamIzle = () => {
    if (!user) { navigate('/giris'); return; }
    if (!isNativeApp_) {
      goster('Bu özellik sadece mobil uygulamada çalışır.', 'hata');
      return;
    }
    setYukleniyor(true);
    window.onRewardEarned = async (amount) => {
      window.onRewardEarned = null;
      window.onRewardFailed = null;
      setYukleniyor(false);
      const ok = await ekleToken(50, 'reklam_izle');
      if (ok) goster('+50 token kazandın! 🎉'); else goster('Bugünlük reklam ödülü sınırına ulaştın, yarın tekrar dene.', 'hata');
    };
    window.onRewardFailed = () => {
      window.onRewardEarned = null;
      window.onRewardFailed = null;
      setYukleniyor(false);
      goster('Reklam tamamlanamadı, tekrar dene.', 'hata');
    };
    showRewardedAd();
    setTimeout(() => {
      if (window.onRewardFailed) {
        window.onRewardFailed();
      }
    }, 120000);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(180deg, #0a0718 0%, #110d24 40%, #0d0a1a 100%)', position: 'relative', overflow: 'hidden', fontFamily: "'Trebuchet MS', Tahoma, sans-serif", maxWidth: 420, margin: '0 auto' }}>
      <style>{`
        @keyframes kart-gir { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes mesaj-gir { from { opacity: 0; transform: translateY(-20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes nabiz { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { display: none; }
      `}</style>

      <YildizArkaplan />

      {mesaj && (
        <div style={{
          position: 'fixed', top: 20, left: '50%', transform: 'translateX(-50%)',
          zIndex: 999, background: mesaj.tur === 'hata' ? 'rgba(220,50,50,0.95)' : 'rgba(34,197,94,0.95)',
          border: mesaj.tur === 'hata' ? '1px solid rgba(255,100,100,0.5)' : '1px solid rgba(74,222,128,0.5)',
          borderRadius: 14, padding: '12px 22px', fontSize: 14, color: '#fff', fontWeight: 700,
          animation: 'mesaj-gir 0.3s ease', whiteSpace: 'nowrap',
        }}>
          {mesaj.metin}
        </div>
      )}

      <div style={{ position: 'relative', zIndex: 1, paddingBottom: 90 }}>

        <div style={{ padding: '24px 20px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button onClick={() => navigate(-1)} style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 12, width: 38, height: 38, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, color: '#fff', cursor: 'pointer' }}>‹</button>
            <div>
              <div style={{ fontSize: 20, fontWeight: 700, color: '#fff' }}>Token Kazan</div>
              <div style={{ fontSize: 11, color: 'rgba(167,139,250,0.6)', marginTop: 2 }}>Reklam izle, token kazan</div>
            </div>
          </div>
          <div style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 20, padding: '6px 14px', display: 'flex', alignItems: 'center', gap: 6, fontSize: 14, color: '#F9CB42', fontWeight: 700 }}>
            <span>🪙</span><span>{tokenBalance}</span>
          </div>
        </div>

        <div style={{ padding: '0 20px' }}>

          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <div style={{ fontSize: 64, marginBottom: 12, animation: 'nabiz 2s ease-in-out infinite' }}>🎁</div>
            <div style={{ fontSize: 16, color: 'rgba(255,255,255,0.7)', lineHeight: 1.6 }}>
              Reklam izle, anında token kazan.<br />Her izlemede <span style={{ color: '#F9CB42', fontWeight: 700 }}>+50 token</span> hesabına yüklenir.
            </div>
          </div>

          <button
            onClick={reklamIzle}
            disabled={yukleniyor}
            style={{
              width: '100%', padding: '18px', borderRadius: 16,
              background: yukleniyor ? 'rgba(255,255,255,0.08)' : 'linear-gradient(135deg, #7c3aed, #a855f7)',
              border: 'none', color: yukleniyor ? 'rgba(255,255,255,0.3)' : '#fff',
              fontSize: 16, fontWeight: 700, cursor: yukleniyor ? 'default' : 'pointer',
              marginBottom: 16,
            }}
          >
            {yukleniyor ? '⏳ Reklam yükleniyor...' : '▶ Reklam İzle — +50 🪙'}
          </button>

          {!isNativeApp_ && (
            <div style={{ textAlign: 'center', fontSize: 12, color: 'rgba(255,255,255,0.3)', marginTop: 8 }}>
              Bu özellik Android uygulamasında kullanılabilir
            </div>
          )}

          <div style={{ marginTop: 32, borderRadius: 16, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', padding: '16px' }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#fff', marginBottom: 12 }}>💡 Nasıl çalışır?</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {[
                { emoji: '▶', text: 'Reklam İzle butonuna bas' },
                { emoji: '📺', text: 'Kısa reklamı sonuna kadar izle' },
                { emoji: '🪙', text: '50 token anında hesabına yüklenir' },
                { emoji: '🔄', text: 'İstediğin kadar tekrarla' },
              ].map((adim, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'rgba(167,139,250,0.15)', border: '1px solid rgba(167,139,250,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, flexShrink: 0 }}>
                    {adim.emoji}
                  </div>
                  <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.65)' }}>{adim.text}</div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
